var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShieldExpiredIcon = function SvgShieldExpiredIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    fillRule: "evenodd",
    d: "M7 0 0 2.667v4.175C0 11.484 2.924 14.534 7 16c4.076-1.466 7-4.516 7-9.158V2.667zM4.726 4.726a1.02 1.02 0 0 0-1.453 0l.454-.453a1.024 1.024 0 0 0 0 1.453L6 8l-2.274 2.274a1.02 1.02 0 0 0 0 1.453l-.453-.454a1.024 1.024 0 0 0 1.453 0L7 9l2.274 2.274a1.02 1.02 0 0 0 1.453 0l-.454.453a1.024 1.024 0 0 0 0-1.453L8 8l2.274-2.274a1.02 1.02 0 0 0 0-1.453l.453.454a1.024 1.024 0 0 0-1.453 0L7 7z"
  })));
};
export default SvgShieldExpiredIcon;